module.exports = __webpack_public_path__ + "static/media/super-admin.d7c632a1.svg";